import { render, staticRenderFns } from "./StudentPracticalWork.vue?vue&type=template&id=d3e606ae&scoped=true"
import script from "./StudentPracticalWork.vue?vue&type=script&lang=js"
export * from "./StudentPracticalWork.vue?vue&type=script&lang=js"
import style0 from "./StudentPracticalWork.vue?vue&type=style&index=0&id=d3e606ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e606ae",
  null
  
)

export default component.exports